<template>
  <div v-if="hasMore" class="load-more">
    <button
      type="button"
      class="btn btn-secondary btn-sm load-more-btn"
      :disabled="disabled || loading"
      @click="$emit('click')"
    >
      {{ loading ? 'Загрузка...' : 'Загрузить ещё' }}
    </button>
  </div>
</template>

<script setup>
defineProps({
  hasMore: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['click'])
</script>

<style scoped>
.load-more {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
}

.load-more-btn {
  min-width: 8rem;
}
</style>
